import clsx from "clsx";
import { DetailedHTMLProps, HTMLAttributes, useEffect } from "react";
import classes from "./Backdrop.module.scss";

type PropsType = {};

const Backdrop = (props: PropsType & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  const { className, ...rest } = props;

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "unset";
    };
  }, []);

  return <div className={clsx(className, classes.backdrop)} {...rest}></div>;
};

export default Backdrop;
